<db-dialog-wrapper [dialog]="this" [width]="'488px'">
  <div class="db-email-verification">
    <div>
      <form >
        <h2 [innerHTML]="'text_emailVerification.title1' | dbText" *ngIf="!emailSent && type !== 'fromSuccess'"></h2>
        <h2 [innerHTML]="'text_emailVerification.title2' | dbText" *ngIf="emailSent && type !== 'fromSuccess'"></h2>
        <img *ngIf="type === 'fromSuccess'" src="assets/images/icons/checkmark_yellow_white_bg.svg" alt=""/>
        <h2 [innerHTML]="'text_optimizerOptimizeSuccess' | dbText" *ngIf="type === 'fromSuccess'"></h2>
        <div *ngIf="!emailSent">
          <p [innerHTML]="'text_emailVerification.wpadmin' | dbText" *ngIf="type === 'fromAdminURL'"></p>
          <p [innerHTML]="'text_emailVerification.users' | dbText" *ngIf="type === 'fromUsersURL'"></p>
          <p [innerHTML]="'text_emailVerification.uploadPlugin' | dbText" *ngIf="type === 'fromProductUpload'"></p>
          <p [innerHTML]="'text_emailVerification.phpmyadmin' | dbText" *ngIf="type === 'fromDbURL'"></p>
          <p [innerHTML]="'text_emailVerification.seo' | dbText" *ngIf="type === 'fromSeoUrl'"></p>
          <p [innerHTML]="'text_emailVerification.successDesc' | dbText" *ngIf="type === 'fromSuccess'"></p>
          <p *ngIf="type !== 'fromSuccess'"><span [innerHTML]="'text_emailVerification.cantFind' | dbText"></span><span [innerHTML]="'text_emailVerification.resendEmail' | dbText" class="db-link" (click)="resendEmail()"></span></p>
        </div>

        <p [innerHTML]="'text_emailVerification.Desc2' | dbText" *ngIf="emailSent"></p>

        <div class="db-server-error" *ngIf="serverErrors">{{serverErrors?.message}}</div>
        <div class="db-buttons">
          <a class="db-button db-button_info" (click)="closeDialog()" [ngClass]="{'db-button_disabled': loading}">
            <span *ngIf="!loading" >{{'text_emailVerification.gotIt' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
          </a>
        </div>
      </form>
    </div>
  </div>
</db-dialog-wrapper>
